module.exports = __webpack_public_path__ + "static/media/feature-mini-card1.104350f1.png";